import { createClient } from '@supabase/supabase-js';

// Separate client instance — used only for creating new users via signUp()
// This prevents the admin's current session from being replaced
const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseAdmin = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    persistSession: false,   // ← session save nahi hogi
    autoRefreshToken: false, // ← admin session affect nahi hogi
  },
});